import { useCallback, useState, MouseEvent } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { setPrimaryContact as setLeadPrimaryContact } from '@user/store/lead'
import { setPrimaryContact as setOppPrimaryContact } from '@user/store/opportunity'
import { CardVariants, ContactCardProps } from '../typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { toast } from '@sales-center/components'

export function useActions(params: ContactCardProps) {
  const { entityType, entityId, contact, variant } = params

  const dispatch = useAppDispatch()

  const [showMoreButton, setShowMoreButton] = useState(false)
  const [showAll, setShowAll] = useState(false)

  const onChangePrimaryContact = useCallback(async () => {
    const func =
      entityType === ENTITY_TYPES.Lead
        ? setLeadPrimaryContact
        : setOppPrimaryContact

    const response = await dispatch(
      func({
        id: entityId,
        contactId: contact.id,
        externalLinkId: contact.externalLinkId,
        externalLocationCode: contact.locationCode,
        isExternalContact: variant !== CardVariants.wwm,
      }),
    )
    if (func.fulfilled.match(response)) {
      if (response.payload.draftAgreementsUpdated) {
        toast.success(
          'Contact information has been updated on any draft agreements.',
        )
      }
    } else {
      toast.error('Failed to change primary contact.')
    }
  }, [
    contact.externalLinkId,
    contact.id,
    contact.locationCode,
    dispatch,
    entityId,
    entityType,
    variant,
  ])

  const handleShowInfoClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      setShowAll((current) => !current)
    },
    [],
  )

  const handleOverflow = useCallback(
    (overflow: boolean) => setShowMoreButton(overflow),
    [],
  )

  return {
    onChangePrimaryContact,
    showAll,
    handleShowInfoClick,
    showMoreButton,
    handleOverflow,
  }
}
